export const EditFormMessageFromIframeType = {
  PENDING_SAVE: 'PENDING_SAVE',
  CHANGES_SAVED: 'CHANGES_SAVED',
  SAVE_ERROR: 'SAVE_ERROR',
  RELOAD: 'RELOAD',
  SWITCH_TO_V1: 'SWITCH_TO_V1'
} as const;

export type PendingSaveMessage = { type: typeof EditFormMessageFromIframeType.PENDING_SAVE };

export type ChangesSavedMessage = {
  type: typeof EditFormMessageFromIframeType.CHANGES_SAVED;
  version: number;
};

export type SaveErrorMessage = { type: typeof EditFormMessageFromIframeType.SAVE_ERROR };

export type ReloadMessage = { type: typeof EditFormMessageFromIframeType.RELOAD, path?: string };

export type SwitchToV1Message = { type: typeof EditFormMessageFromIframeType.SWITCH_TO_V1 };

export type EditFormMessageFromIframe =
  | PendingSaveMessage
  | ChangesSavedMessage
  | SaveErrorMessage
  | ReloadMessage
  | SwitchToV1Message;

export const isEditFormMessageFromIframe = (data: unknown): data is EditFormMessageFromIframe => {
  if (typeof data !== 'object' || data === null || !('type' in data)) {
    return false;
  }

  const messageType = (data as { type: string }).type;
  return (Object.values(EditFormMessageFromIframeType) as Array<string>).includes(messageType);
};

export const EditFormMessageToIframeType = {
  VERSION_UPDATED: 'VERSION_UPDATED'
} as const;

export type VersionUpdatedMessage = {
  type: typeof EditFormMessageToIframeType.VERSION_UPDATED;
  version: number;
  reason: 'publish' | 'unpublish';
};

export type EditFormMessageToIframe =
  | VersionUpdatedMessage;
